<template>
  <MDBCard class="container-height mt-3 mt-lg-4">
    <MDBCardBody>
      <div class="tyre-box-text">
        <div v-if="yearlyOutput">
          <div v-for="(tyres, index) in yearlyOutput" :key="index">
            <b>{{ $t("wholesaler.dashboard.overview.all") }} {{ $t("contact.form.tires").toLocaleLowerCase() }} {{
              tyres.year }}:</b> {{
                tyres.yearly_sum }}
          </div>
        </div>
        <div v-if="yearlyOutput">
          <div>
            <b>13-16":</b>
            {{ currentYearRimSummary?.["13_16"] ?? 0 }} |
            <b>17-18":</b>
            {{ currentYearRimSummary?.["17_18"] ?? 0 }} |
            <b>19"+:</b>
            {{ currentYearRimSummary?.["19_plus"] ?? 0 }}
          </div>
        </div>
        <div v-else>
          <div>
            <b>13-16":</b> 0 |
            <b>17-18":</b> 0 |
            <b>19"+:</b> 0
          </div>
        </div>
        <div class="pt-0 p-relative">
          <b>{{ $t("tyreBox.target") }} {{ currentYear }}:&nbsp;</b><span
            v-if="bonusMultiplicator.length > 0 && checkUserGoal()">{{
              $t(`multiplicator.goals.${checkUserGoal().name}`) }}
          </span>
          <span v-else>{{ $t('multiplicator.chooseTarget') }}</span>
          <span class="info-notification cursor--pointer" @click="openModal()">!</span>
        </div>
        <div class="pt-0" v-if="bonusMultiplicator.length > 0 && checkUserGoal()">
          <span v-html="$t('multiplicator.minTyres', {
            tyre: checkUserGoal().min_tyres
          })"></span>
        </div>
        <div class="pt-0" v-if="bonusMultiplicator.length > 0 && checkUserGoal()">
          <b>{{
            $t(`multiplicator.goals.${checkUserGoal().name}`) }} bonus = X {{ checkUserGoal().factor }}</b>
        </div>
        <div class="pt-0">
          <b>{{ $t("tyreBox.entry") }} {{ currentYear }}:</b> {{ shopLimit?.limit }}
          <span class="text-lowercase">{{ $t("tyreBox.title") }}</span>
        </div>
      </div>
    </MDBCardBody>
    <MDBModal v-model="modal" tabindex="-1" centered size="xl">
      <Loader :show="loading" v-if="loading" />
      <MDBCard v-else>
        <MDBCardBody>
          <MultiplicatorInfo />
        </MDBCardBody>
      </MDBCard>
    </MDBModal>
  </MDBCard>
</template>

<script setup>
import Loader from "@/components/General/Loader/index.vue";
import MultiplicatorInfo from "@/components/KickbackFee/MultiplicatorInfo.vue";
import {
  MDBCard,
  MDBCardBody,
  MDBModal
} from "mdb-vue-ui-kit";
import { useStore } from "vuex";
import { computed, onMounted, ref } from "vue";

const store = useStore();

const user = computed(() => store.getters.getMe);
const shopLimit = computed(() => store.getters.getTyreLimit);
const bonusMultiplicator = computed(() => store.getters.getBonusMultiplicator);
const pointBonusByYear = computed(() => store.getters.getPointBonusByYear);
const currentYear = new Date().getFullYear()
const yearlyOutput = computed(() => pointBonusByYear.value?.output ?? pointBonusByYear.value ?? null);
const loading = computed(() => store.getters.getPending);
const currentYearRimSummary = computed(() =>
  yearlyOutput.value?.[currentYear]?.yearly_sum_by_rim ??
  yearlyOutput.value?.[String(currentYear)]?.yearly_sum_by_rim ??
  null
);

const modal = ref(false)

const openModal = () => {
  modal.value = true;
};
const initialData = async () => {
  const currentYear = new Date().getFullYear()
  await store.dispatch('fetchTyreLimit', currentYear)
}


const checkUserGoal = () => {
  if (bonusMultiplicator.value.length > 0) {
    const goal = bonusMultiplicator.value.find(bonus => bonus.id === user.value.bonus_multiplicator_id)
    return goal ? goal : null
  }
  return false
}
onMounted(async () => {
  await initialData()
})
</script>

<style scoped lang="scss">
@import "../../styles/_variables.scss";
@import "@/styles/welcome_box.scss";
@import "@/styles/mailbox.scss";
@import "@/styles/points_overview.scss";
@import "@/styles/tyre_box.scss";
</style>
